import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
	`px-3 py-2 text-sm font-medium transition ${isActive ? 'text-primary' : 'text-gray-600 hover:text-primary'} `;

export default function SiteLayout() {
	const location = useLocation();
	const isHomePage = location.pathname === '/';

	return (
		<div className={`${isHomePage ? '' : 'min-h-full'} flex flex-col`}>
			<header className={`${isHomePage ? 'absolute top-0 left-0 right-0 z-50 border-b border-gray-800/50 bg-secondary/80 backdrop-blur-md supports-[backdrop-filter]:bg-secondary/70' : 'sticky top-0 z-40 border-b bg-white/70 backdrop-blur supports-[backdrop-filter]:bg-white/60'}`}>
				{isHomePage ? (
					<div className="container flex h-16 items-center justify-center">
						<Link to="/" className="flex items-center gap-2">
							<img src="https://ubiquityglass.com/img/ubiquityLogoGradient.svg" alt="Ubiquity Automotive" className="h-8 md:h-[2.55rem] w-auto" />
							<span className="sr-only">Ubiquity Automotive</span>
						</Link>
					</div>
				) : (
					<div className="container flex h-16 items-center justify-between">
						<Link to="/" className="flex items-center gap-2">
							<img src="https://ubiquityglass.com/img/ubiquityLogoGradient.svg" alt="Ubiquity Automotive" className="h-8 md:h-[2.55rem] w-auto" />
							<span className="sr-only">Ubiquity Automotive</span>
						</Link>
						<nav className="hidden md:flex items-center gap-1">
							<NavLink to="/services" className={navLinkClass}>Services</NavLink>
							<NavLink to="/solutions" className={navLinkClass}>Solutions</NavLink>
							<NavLink to="/resources" className={navLinkClass}>Resources</NavLink>
							<NavLink to="/support" className={navLinkClass}>Support</NavLink>
							<NavLink to="/contact" className={navLinkClass}>Contact</NavLink>
						</nav>
						<div className="flex items-center gap-2">
							<a href="https://realm.ubiquityauto.com/order/2dcf3188-0a07-4444-b5f8-065a5dc238bb?access_token=_ha6LYxaO-9HjbYZVCY7P21vuKFFRaQ5" target="_blank" rel="noreferrer">
								<Button variant="outline" size="sm" className="border-royalpurple text-royalpurple">Get Started</Button>
							</a>
							<a href="https://ubiquityglass.com/" target="_blank" rel="noreferrer">
								<Button size="sm" className="bg-gradient-to-r from-primary via-babyblue to-royalpurple text-white">Login</Button>
							</a>
						</div>
					</div>
				)}
			</header>
			<main className="flex-1">
				<Outlet />
			</main>
			{!isHomePage && (
				<footer className="border-t py-12 text-sm text-gray-600">
					<div className="container grid md:grid-cols-4 gap-8">
						<div>
							<img src="https://ubiquityglass.com/img/ubiquityLogoGradient.svg" alt="Ubiquity Automotive" className="h-7 md:h-8 w-auto" />
							<p className="mt-2">On‑demand automotive services with centralized hubs for complex repairs.</p>
						</div>
						<div>
							<div className="font-semibold">Services</div>
							<ul className="mt-2 space-y-1">
								<li><Link to="/services/engine" className="hover:text-secondary">Engine</Link></li>
								<li><Link to="/services/transmission" className="hover:text-secondary">Transmission</Link></li>
								<li><Link to="/services/suspension" className="hover:text-secondary">Suspension</Link></li>
								<li><Link to="/services/glass" className="hover:text-secondary">Glass</Link></li>
								<li><Link to="/services/body" className="hover:text-secondary">Body</Link></li>
								<li><Link to="/services/electrical" className="hover:text-secondary">Electrical</Link></li>
								<li><Link to="/services/ac" className="hover:text-secondary">A/C</Link></li>
								<li><Link to="/services/programming" className="hover:text-secondary">Programming & Tuning</Link></li>
								<li><Link to="/services/aftermarket" className="hover:text-secondary">Aftermarket</Link></li>
								<li><Link to="/services/tint" className="hover:text-secondary">Tint</Link></li>
							</ul>
						</div>
						<div>
							<div className="font-semibold">Company</div>
							<ul className="mt-2 space-y-1">
								<li><Link to="/solutions" className="hover:text-secondary">Solutions</Link></li>
								<li><Link to="/resources" className="hover:text-secondary">Resources</Link></li>
								<li><Link to="/support" className="hover:text-secondary">Support</Link></li>
								<li><Link to="/contact" className="hover:text-secondary">Contact</Link></li>
							</ul>
						</div>
						<div>
							<div className="font-semibold">Legal</div>
							<ul className="mt-2 space-y-1">
								<li><Link to="/privacy" className="hover:text-secondary">Privacy</Link></li>
								<li><Link to="/terms" className="hover:text-secondary">Terms</Link></li>
							</ul>
						</div>
					</div>
					<div className="container mt-8 gradient-divider" />
					<div className="container mt-6 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
						<div>© 2025 Ubiquity Automotive, Inc. All Rights Reserved.</div>
						<div className="text-gray-500">Built with AI automation and care.</div>
					</div>
				</footer>
			)}
		</div>
	);
}
